import React from "react";

/**
 * Skeleton loader that mirrors the exact layout of the Heatmap View table
 * (TabularInsights component) so the loading state looks identical to the
 * real table before data arrives.
 */
const HeatmapTableLoading = () => {
  const shimmerClass =
    "bg-gray-200 rounded animate-pulse";

  return (
    <div className="bg-white rounded-lg p-4 relative">
      {/* ── Top bar: Total URLs badge + Search + Date dropdown ── */}
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        {/* "Total URLs: …" badge placeholder */}
        <div className={`${shimmerClass} h-7 w-28`} />

        {/* Search input placeholder */}
        <div className="relative flex-1 w-full max-w-2xl min-w-[200px]">
          <div className={`${shimmerClass} h-9 w-full rounded-lg`} />
        </div>

        {/* Date dropdown placeholder */}
        <div className={`${shimmerClass} h-9 w-36 rounded-md`} />
      </div>

      {/* ── Table ── */}
      <div className="overflow-x-auto">
        <table className="w-full divide-y divide-gray-200 border-2">
          <thead className="bg-gray-50">
            <tr>
              {[
                "Page URL",
                "Total Clicks",
                "Avg. Cursor Moves",
                "Scroll Depth (%)",
                "Detailed View",
                "Action",
              ].map((header) => (
                <th
                  key={header}
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {Array.from({ length: 10 }).map((_, rowIdx) => (
              <tr key={rowIdx} className="hover:bg-gray-50">
                {/* Page URL — wider */}
                <td className="px-6 py-4 max-w-xs">
                  <div className={`${shimmerClass} h-4 w-48`} />
                </td>
                {/* Total Clicks */}
                <td className="px-6 py-4 text-right">
                  <div className={`${shimmerClass} h-4 w-10 ml-auto`} />
                </td>
                {/* Avg. Cursor Moves */}
                <td className="px-6 py-4 text-right">
                  <div className={`${shimmerClass} h-4 w-10 ml-auto`} />
                </td>
                {/* Scroll Depth */}
                <td className="px-6 py-4 text-right">
                  <div className={`${shimmerClass} h-4 w-12 ml-auto`} />
                </td>
                {/* Detailed View button */}
                <td className="px-6 py-4">
                  <div className={`${shimmerClass} h-7 w-24 rounded-md`} />
                </td>
                {/* Action button */}
                <td className="px-2 py-4">
                  <div className={`${shimmerClass} h-7 w-32 rounded-md ml-2`} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ── Pagination ── */}
      <div className="mt-4 flex justify-center">
        <nav className="flex items-center space-x-2">
          {/* «  <  pages  >  » */}
          {Array.from({ length: 7 }).map((_, i) => (
            <div
              key={i}
              className={`${shimmerClass} h-8 ${i === 0 || i === 6 ? "w-8" : i === 3 ? "w-10" : "w-8"} rounded`}
            />
          ))}
        </nav>
      </div>
    </div>
  );
};

export default HeatmapTableLoading;
